var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-5 pt-lg-8"},[_c('router-link',{staticClass:"text-center",attrs:{"to":"/"}},[_c('img',{staticClass:"max-h-45px px-3",staticStyle:{"object-fit":"contain","width":"100%"},attrs:{"src":"/images/logo-medhop-transparent.png","alt":"Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }